import {createSvgIcon} from '../create-svg-icon';

export const FormatStrikethroughIcon = createSvgIcon(
  <path d="M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z" />
, 'FormatStrikethroughOutlined');
